import React, { FunctionComponent, useState } from "react";
import { toast } from "react-toastify";
import Form from "@rjsf/react-bootstrap";
import { useNavigate } from "react-router";
import validator from "@rjsf/validator-ajv8";

import { BackButton } from "../common/button/Buttons";
import { ContentLayout } from "../common/Layout";
import FirebaseService from "../../actions/firebase/FirebaseActions";
import { useAuthentication } from "../../hooks/useAuthentication";
import { createLimitEditorSchema } from "./CreateLimitEditorSchema";
import AddLimit from "../../models/limit/AddLimit";
import { trackEvent } from "../../helper/analytics";
import { useUserIdParam } from "../../hooks/useUserIdParam";
import { LIMIT_FORM_ID } from "./limitEditorForm";

interface Props {
  isAuthenticated: boolean;
}

const CreateLimitEditor: FunctionComponent<Props> = ({ isAuthenticated }) => {
  const userId = useUserIdParam();
  useAuthentication(isAuthenticated);
  const navigate = useNavigate();
  const [isSaving, setSaving] = useState(false);

  const saveLimit = (formData: unknown): void => {
    const {
      property,
      limit: formLimit,
      price: formPrice
    } = formData as {
      property: string;
      limit: number;
      price: number;
    };
    const limit: AddLimit = {
      property: property,
      limit: formLimit,
      price: formPrice || 0
    };

    setSaving(true);
    FirebaseService.addLimit(userId, limit)
      .then(() => {
        toast.success("Das Angebot wurde erstellt");
        navigate(`/user/${userId}/limits`);
      })
      .catch((reason) => {
        console.log(reason);
        toast.error(
          "Es ist ein Fehler beim Speichern der Daten aufgetreten. Bitte laden Sie die Applikation erneut und versuchen Sie es noch einmal."
        );
      })
      .finally(() => {
        setSaving(false);
        trackEvent("create-limit");
      });
  };
  return (
    <ContentLayout title={"Angebot erstellen"} siteTitle={"Spielgruppe Online - Angebot erstellen"} maxWidth={740}>
      <div className="editor-toolbar">
        <BackButton to={`/user/${userId}/limits`} />
        <button type="submit" form={LIMIT_FORM_ID} disabled={isSaving} className="btn btn-primary editor-toolbar__save">
          Speichern
        </button>
      </div>
      <section className="panel">
        <div className="panel__body">
          <Form
            id={LIMIT_FORM_ID}
            validator={validator}
            formData={{}}
            schema={createLimitEditorSchema}
            onSubmit={(e) => saveLimit(e.formData)}>
            <button type="submit" disabled={isSaving} className="btn btn-primary">
              Speichern
            </button>
          </Form>
        </div>
      </section>
    </ContentLayout>
  );
};

export default CreateLimitEditor;
